<!-- MyInputComponent.vue -->
<template>
	<div class="flex w-full flex-col gap-[8px]">
		<BaseInputFieldFloating
			:value="modelValue"
			@input="updateValue"
			:type="type"
			:label="label"
			:placeholder="placeholder"
			:isError="isError"
			:disabled="disabled"
			:inputMode="inputMode"
			:countryCode="countryCode"
			:isLazy="isLazy"
			:isLogin="isLogin"
			:autoComplete="autoComplete"
		>
			<template #lastused>
				<BaseTag variant="highlight" size="medium">Last used</BaseTag>
			</template>
		</BaseInputFieldFloating>
		<BaseMessageDisplay
			:errorMessage="errorMessage || ''"
			:infoMessage="infoMessage"
			:isError="isError"
			:disabled="disabled"
		/>
	</div>
</template>

<script setup lang="ts">
import BaseInputFieldFloating from '@/components/ui/input/BaseInputFieldFloating.vue'
import BaseMessageDisplay from '@/components/ui/input/BaseMessageDisplay.vue'
import BaseTag from '@/components/ui/tag/BaseTag.vue'

const props = defineProps({
	modelValue: {
		type: String,
		required: true,
	},
	type: {
		type: String,
		default: 'text',
	},
	label: {
		type: String,
		required: true,
	},
	placeholder: {
		type: String,
		default: '',
	},
	isError: {
		type: Boolean,
		required: true,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	infoMessage: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	inputMode: {
		type: String,
		default: '',
	},
	countryCode: {
		type: String,
		default: '',
	},
	isLazy: {
		type: Boolean,
		default: true,
	},
	isLogin: {
		type: Boolean,
		default: false,
	},
	autoComplete: {
		type: String,
		default: 'on',
	},
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (newValue: string) => {
	emit('update:modelValue', newValue)
}
</script>
